/* ──── TEAM PORTAL PIN GATE ─────────────────────── */
const TEAM_PIN = '2024';  // ← Change this to your own code
const PIN_KEY  = 'lf_team_auth';

function isTeamAuthed() {
  return localStorage.getItem(PIN_KEY) === TEAM_PIN;
}

function showPinGate() {
  // Build the PIN overlay
  const overlay = document.createElement('div');
  overlay.id = 'pin-overlay';
  overlay.style.cssText = `
    position:fixed;inset:0;background:rgba(0,0,0,0.85);z-index:9999;
    display:flex;align-items:center;justify-content:center;
    font-family:'Inter',-apple-system,sans-serif;
  `;
  overlay.innerHTML = `
    <div style="background:#fff;border-radius:12px;padding:40px 36px;width:100%;max-width:360px;text-align:center;box-shadow:0 24px 64px rgba(0,0,0,0.3)">
      <div style="width:48px;height:48px;background:#111;border-radius:50%;margin:0 auto 20px;display:flex;align-items:center;justify-content:center">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#3ecb6a" stroke-width="2.5"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg>
      </div>
      <div style="font-size:11px;font-weight:700;letter-spacing:0.14em;text-transform:uppercase;color:#999;margin-bottom:8px">Team Portal</div>
      <div style="font-size:22px;font-weight:700;letter-spacing:-0.02em;color:#111;margin-bottom:6px">Employee access only</div>
      <div style="font-size:13px;color:#999;margin-bottom:24px;line-height:1.5">Enter the team access code to continue.</div>
      <input id="pin-input" type="password" placeholder="Access code"
        style="width:100%;border:1.5px solid #e0e0e0;border-radius:8px;padding:12px 14px;font-size:15px;font-family:inherit;outline:none;text-align:center;letter-spacing:0.2em;margin-bottom:12px"
        onkeydown="if(event.key==='Enter')checkPin()"
        onfocus="this.style.borderColor='#3ecb6a'"
        onblur="this.style.borderColor='#e0e0e0'"
      />
      <div id="pin-error" style="color:#d93535;font-size:12px;margin-bottom:10px;min-height:18px"></div>
      <button onclick="checkPin()"
        style="width:100%;background:#3ecb6a;color:#fff;border:none;border-radius:100px;padding:13px;font-size:13px;font-weight:600;cursor:pointer;font-family:inherit;transition:background 0.14s"
        onmouseover="this.style.background='#2db559'"
        onmouseout="this.style.background='#3ecb6a'"
      >Unlock Team Portal</button>
      <button onclick="cancelPin()"
        style="width:100%;background:none;border:none;color:#999;font-size:12px;cursor:pointer;margin-top:12px;font-family:inherit;padding:4px"
      >← Back to claim form</button>
    </div>
  `;
  document.body.appendChild(overlay);
  setTimeout(() => document.getElementById('pin-input')?.focus(), 100);
}

function checkPin() {
  const input = document.getElementById('pin-input');
  const error = document.getElementById('pin-error');
  if (!input) return;
  if (input.value === TEAM_PIN) {
    localStorage.setItem(PIN_KEY, TEAM_PIN);
    document.getElementById('pin-overlay')?.remove();
    // Now actually switch to team view
    const btn = document.querySelector('.nav-link:last-child');
    if (btn) switchView('team', btn);
  } else {
    error.textContent = 'Incorrect code. Try again.';
    input.value = '';
    input.style.borderColor = '#d93535';
    setTimeout(() => { input.style.borderColor = '#e0e0e0'; }, 1500);
    input.focus();
  }
}

function cancelPin() {
  document.getElementById('pin-overlay')?.remove();
}

function teamLogout() {
  localStorage.removeItem(PIN_KEY);
  // Switch back to customer view
  const btn = document.querySelector('.nav-link:first-child');
  if (btn) switchView('customer', btn);
}

/* ──── DATA ──────────────────────────────────────── */
let claims = JSON.parse(localStorage.getItem('lf5') || '[]');
let filt   = { status:'all', type:null, issue:null };
let gCfg   = JSON.parse(localStorage.getItem('lf5_gorgias') || '{}');
let activeClaimId = null;
// Make mutable state accessible globally
window._lfState = { get claims(){ return claims; }, get filt(){ return filt; } };

const save    = () => localStorage.setItem('lf5', JSON.stringify(claims));
const saveCfgData = () => localStorage.setItem('lf5_gorgias', JSON.stringify(gCfg));
const $       = id => document.getElementById(id);



if (!claims.length) {
  claims = [
    {id:'CLM-001',name:'Jonas Berg',        email:'jonas@example.com',   order:'#LF10421',po:'PO-2024-0831',type:'Shirt',          colour:'Arctic White', issue:'Stain-repellent not working',     desc:'After 3 washes at 30°C the shirt no longer repels coffee or water. Started noticing after the second wash.',                                                                                      status:'New',     date:'2025-03-08',img:null},
    {id:'CLM-002',name:'Mads Christensen',  email:'mads@example.dk',     order:'#LF10389',po:'PO-2024-0775',type:'Pants',          colour:'Charcoal',     issue:'Stitching / Seam failure',        desc:'The inner seam on the right leg has split ~8cm up from the cuff. Worn 10–12 times, never tumble dried.',                                                                                    status:'New',     date:'2025-03-06',img:null},
    {id:'CLM-003',name:'Leah Müller',  email:'leah@example.de',     order:'#LF10401',po:'PO-2024-0812',type:'T-Shirt',        colour:'Navy',         issue:'Odour resistance failure',        desc:'Persistent odour after about a month of regular use despite following all wash instructions.',                                                                                                     status:'New',     date:'2025-03-07',img:null},
    {id:'CLM-004',name:'Pieter van Dam',    email:'pieter@example.nl',   order:'#LF10355',po:'PO-2024-0744',type:'Knitwear',       colour:'Oatmeal',      issue:'Pilling or fabric deterioration', desc:'Heavy pilling across chest and sleeves after only 4 wears. Washed inside-out at 30°C.',                                                                                                    status:'Resolved',date:'2025-02-28',img:null},
    {id:'CLM-005',name:'Sofie Andersen',    email:'sofie@example.dk',    order:'#LF10412',po:'PO-2024-0822',type:'LIV by LABFRESH',colour:'Sage',         issue:'Sizing discrepancy',              desc:'Ordered M per the size guide. Waist is 4cm smaller than listed. Very different to what was advertised.',                                                                                          status:'New',     date:'2025-03-09',img:null},
    {id:'CLM-006',name:'Tom Bakker',        email:'tom@example.com',     order:'#LF10395',po:'PO-2024-0788',type:'Outerwear',      colour:'Black',        issue:'Zipper, button or hardware issue', desc:'Main zip separating from the bottom after just 2 months of light use.',                                                                                                                          status:'New',     date:'2025-03-05',img:null},
    {id:'CLM-007',name:'Anna Eriksson',     email:'anna@example.se',     order:'#LF10433',po:'PO-2024-0855',type:'Shirt',          colour:'Light Blue',   issue:'Colour fading or bleeding',       desc:'The shirt has faded significantly on the collar and cuffs after only 5 washes at 30°C. The fabric elsewhere looks fine — only the edges are affected.',                              status:'New',     date:'2025-03-11',img:null},
    {id:'CLM-008',name:'Nikolaj Poulsen',   email:'nikolaj@example.dk',  order:'#LF10441',po:'PO-2025-0012',type:'Polo',           colour:'Forest Green', issue:'Fabric treatment degradation',    desc:'After 6 washes the polo no longer sheds water at all. I tested it side by side with a new one and the difference is very clear. Washed at 30°C, no fabric softener, air dried.',           status:'New',     date:'2025-03-12',img:null},
    {id:'CLM-009',name:'Clara Hoffmann',    email:'clara@example.de',    order:'#LF10448',po:'PO-2025-0019',type:'LIV by LABFRESH',colour:'Ivory',        issue:'Fabric defect or tear',           desc:'There is a 3cm snag in the fabric on the front panel of the blouse. It was visible on first unpacking. Looks like a manufacturing pull in the weave.',                                            status:'New',     date:'2025-03-13',img:null},
    {id:'CLM-010',name:'Rasmus Kjær', email:'rasmus@example.dk',   order:'#LF10452',po:'PO-2025-0024',type:'Pants',          colour:'Sand',         issue:'Wrinkle-resistance failure',      desc:'The pants crease heavily after just sitting down for an hour. The previous pair I owned from LABFRESH held their shape all day. These are a completely different experience.',                   status:'New',     date:'2025-03-14',img:null},
    {id:'CLM-011',name:'Elena Marchetti',   email:'elena@example.it',    order:'#LF10458',po:'PO-2025-0031',type:'Undershirt',     colour:'White',        issue:'Stain-repellent not working',     desc:'The undershirt shows sweat stains under the arms after a single wear. I bought it specifically for the sweat-proof technology. Disappointed — this is exactly what I needed it to prevent.', status:'New',     date:'2025-03-14',img:null},
    {id:'CLM-012',name:'Frederik Lund',     email:'frederik@example.dk', order:'#LF10463',po:'PO-2025-0038',type:'Shirt',          colour:'White',        issue:'Wrong item received',             desc:'I ordered the Classic Non-Iron Shirt in White, size L. I received a size M in the same colour. The packing slip inside the box says L but the garment label says M.',                          status:'New',     date:'2025-03-15',img:null},
    {id:'CLM-013',name:'Isabelle Fontaine', email:'isabelle@example.fr', order:'#LF10469',po:'PO-2025-0044',type:'Knitwear',       colour:'Midnight Blue',issue:'Stitching / Seam failure',        desc:'The seam along the right shoulder of the merino crew-neck has come apart after only 3 wears. I have been hand-washing it as instructed and storing it folded.',                               status:'New',     date:'2025-03-15',img:null},
    {id:'CLM-014',name:'Lars Petersen',     email:'lars@example.dk',     order:'#LF10474',po:'PO-2025-0049',type:'T-Shirt',        colour:'Black',        issue:'Damaged on arrival',              desc:'The t-shirt arrived with a small hole near the hem, roughly 1cm. The packaging looked fine so it happened before shipping. I noticed it immediately on first unpacking.',                       status:'New',     date:'2025-03-16',img:null},
    {id:'CLM-015',name:'Nora Svensson',     email:'nora@example.se',     order:'#LF10481',po:'PO-2025-0057',type:'Outerwear',      colour:'Camel',        issue:'Odour resistance failure',        desc:'The jacket has developed a persistent musty smell after two months of use, even after airing it out. I spot-clean it as instructed and have never machine washed it.',                          status:'New',     date:'2025-03-17',img:null},
    {id:'CLM-016',name:'Oliver Brandt',     email:'oliver@example.de',   order:'#LF10487',po:'PO-2025-0063',type:'Polo',           colour:'White',        issue:'Colour fading or bleeding',       desc:'The polo has turned slightly yellow around the collar after 4 washes. I use non-biological detergent at 30°C and never tumble dry.',                                                       status:'Resolved',date:'2025-03-01',img:null},
    {id:'CLM-017',name:'Maria Santos',      email:'maria@example.pt',    order:'#LF10492',po:'PO-2025-0068',type:'LIV by LABFRESH',colour:'Terracotta',   issue:'Sizing discrepancy',              desc:'The LIV trousers in size S are extremely tight across the hips but loose in the waist — the proportions differ significantly from the measurements shown on the size guide.',             status:'New',     date:'2025-03-18',img:null},
    {id:'CLM-018',name:'Henrik Dahl',       email:'henrik@example.dk',   order:'#LF10499',po:'PO-2025-0075',type:'Shirt',          colour:'Navy',         issue:'Zipper, button or hardware issue', desc:'Two of the shirt buttons have cracked — the top button and the third one down. I button the shirt normally and never put it in the dryer. They look like they have fractured from inside.', status:'New',     date:'2025-03-19',img:null},
    {id:'CLM-019',name:'Camille Bernard',   email:'camille@example.fr',  order:'#LF10504',po:'PO-2025-0081',type:'Backpack',        colour:'Black',        issue:'Zipper, button or hardware issue', desc:'The main compartment zip has started splitting open when the bag is more than half full. The slider moves fine but the coil separates behind it. The bag is 6 weeks old.',                   status:'New',     date:'2025-03-19',img:null},
    {id:'CLM-020',name:'Tobias Holm',       email:'tobias@example.dk',   order:'#LF10510',po:'PO-2025-0087',type:'Pants',          colour:'Olive',        issue:'Fabric defect or tear',           desc:'A small tear has appeared on the inner thigh of the right leg after a normal day of wear. No unusual stress was put on the garment. I noticed it when taking them off in the evening.',       status:'New',     date:'2025-03-20',img:null},
  ];
  save();
}

/* ──── VIEW SWITCH ──────────────────────────────── */
function switchView(v, btn) {
  // Guard team portal behind PIN
  if (v === 'team' && !isTeamAuthed()) {
    showPinGate();
    return;
  }
  document.querySelectorAll('.view').forEach(x=>x.classList.remove('active'));
  document.querySelectorAll('.nav-link').forEach(x=>x.classList.remove('active'));
  $('view-'+v).classList.add('active');
  btn.classList.add('active');
  if (v==='team') initTeam();
}

/* ──── CUSTOMER FORM ────────────────────────────── */
function previewImgs(inp) {
  const el=$('img-preview');
  el.innerHTML='';
  Array.from(inp.files).slice(0,5).forEach(f=>{
    const r=new FileReader();
    r.onload=e=>{const img=document.createElement('img');img.src=e.target.result;el.appendChild(img);};
    r.readAsDataURL(f);
  });
}

function submitClaim(e) {
  e.preventDefault();
  const files=Array.from($('f-imgs').files);
  const finish=img=>{
    const id='CLM-'+String(claims.length+1).padStart(3,'0');
    claims.unshift({id,name:$('f-name').value,email:$('f-email').value,order:$('f-order').value,po:$('f-po').value,type:$('f-type').value,colour:$('f-colour').value||'—',issue:$('f-issue').value,desc:$('f-desc').value,status:'New',date:new Date().toISOString().split('T')[0],img});
    save();
    $('ref-pill').textContent=id;
    $('claim-form').style.display='none';
    $('success-screen').classList.add('show');
  };
  if(files.length){const r=new FileReader();r.onload=e=>finish(e.target.result);r.readAsDataURL(files[0]);}
  else finish(null);
}

function resetForm(){
  $('claim-form').reset();
  $('img-preview').innerHTML='';
  $('claim-form').style.display='block';
  $('success-screen').classList.remove('show');
}

/* ──── TEAM VIEW ────────────────────────────────── */
function initTeam(){
  // Add logout button to settings bar if not already there
  const bar = document.querySelector('.settings-bar');
  if (bar && !document.getElementById('team-logout-btn')) {
    const logoutBtn = document.createElement('button');
    logoutBtn.id = 'team-logout-btn';
    logoutBtn.className = 'settings-btn';
    logoutBtn.style.cssText = 'color:#d93535;border-color:#fecaca';
    logoutBtn.innerHTML = `<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9"/></svg> Lock Portal`;
    logoutBtn.onclick = teamLogout;
    bar.insertBefore(logoutBtn, bar.firstChild);
  }
  updateStats(); buildSidebar(); renderCharts(); renderT();
}

/* ──── CHARTS ───────────────────────────────────── */
const CHART_PALETTE = [
  '#3ecb6a','#111111','#f59e0b','#6c47ff','#ef4444',
  '#06b6d4','#84cc16','#f97316','#8b5cf6','#ec4899','#14b8a6'
];

function renderCharts() {
  // Only show charts when "All claims" filter is active (status=all, no type/issue filter)
  const showCharts = filt.status === 'all' && !filt.type && !filt.issue;
  const grid = $('charts-grid');
  grid.style.display = showCharts ? 'grid' : 'none';
  if (!showCharts || !claims.length) return;

  renderIssuesChart();
  renderProductsChart();
  renderDonut();
  renderSparkline();
}

function renderIssuesChart() {
  const counts = {};
  claims.forEach(c => { counts[c.issue] = (counts[c.issue]||0) + 1; });
  const sorted = Object.entries(counts).sort((a,b)=>b[1]-a[1]);
  const max = sorted[0]?.[1] || 1;
  $('chart-issues').innerHTML = sorted.map(([label, val], i) => `
    <div class="bar-row">
      <div class="bar-label" title="${label}">${label}</div>
      <div class="bar-track">
        <div class="bar-fill" style="width:0%;background:${CHART_PALETTE[i%CHART_PALETTE.length]}" data-pct="${Math.round(val/max*100)}"></div>
      </div>
      <div class="bar-val">${val}</div>
    </div>`).join('');
  animateBars($('chart-issues'));
}

function renderProductsChart() {
  const counts = {};
  claims.forEach(c => { counts[c.type] = (counts[c.type]||0) + 1; });
  const sorted = Object.entries(counts).sort((a,b)=>b[1]-a[1]);
  const max = sorted[0]?.[1] || 1;
  $('chart-products').innerHTML = sorted.map(([label, val], i) => `
    <div class="bar-row">
      <div class="bar-label" title="${label}">${label}</div>
      <div class="bar-track">
        <div class="bar-fill" style="width:0%;background:${CHART_PALETTE[i%CHART_PALETTE.length]}" data-pct="${Math.round(val/max*100)}"></div>
      </div>
      <div class="bar-val">${val}</div>
    </div>`).join('');
  animateBars($('chart-products'));
}

function animateBars(container) {
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      container.querySelectorAll('.bar-fill').forEach(el => {
        el.style.width = el.dataset.pct + '%';
      });
    });
  });
}

function renderDonut() {
  const nw = claims.filter(c=>c.status==='New').length;
  const rs = claims.filter(c=>c.status==='Resolved').length;
  const total = claims.length;
  const segments = [
    { label:'New',      val:nw, color:'#d93535' },
    { label:'Resolved', val:rs, color:'#1a8a4a' },
  ].filter(s=>s.val>0);

  const cx=40, cy=40, r=28, stroke=14;
  const circ = 2*Math.PI*r;
  let offset = 0;
  // Start at top (-quarter turn)
  let svgPaths = '';
  segments.forEach(seg => {
    const pct = seg.val / total;
    const dash = pct * circ;
    const gap  = circ - dash;
    svgPaths += `<circle cx="${cx}" cy="${cy}" r="${r}"
      fill="none" stroke="${seg.color}" stroke-width="${stroke}"
      stroke-dasharray="${dash.toFixed(2)} ${gap.toFixed(2)}"
      stroke-dashoffset="${(circ - offset).toFixed(2)}"
      style="transition:stroke-dasharray 0.6s ease"/>`;
    offset += dash;
  });

  // Centre text
  svgPaths += `<text x="${cx}" y="${cy+1}" text-anchor="middle" dominant-baseline="middle"
    font-family="Helvetica Neue,Arial,sans-serif" font-size="15" font-weight="700" fill="#111">${total}</text>
  <text x="${cx}" y="${cy+14}" text-anchor="middle" dominant-baseline="middle"
    font-family="Inter,sans-serif" font-size="8" fill="#999">TOTAL</text>`;

  $('chart-donut').innerHTML = svgPaths;
  $('chart-donut-legend').innerHTML = segments.map(s => `
    <div class="legend-row">
      <div class="legend-dot" style="background:${s.color}"></div>
      <div class="legend-label">${s.label}</div>
      <div class="legend-val">${s.val}</div>
    </div>`).join('');
}

function renderSparkline() {
  // Build monthly buckets — last 6 months
  const months = [];
  const now = new Date();
  for (let i=5; i>=0; i--) {
    const d = new Date(now.getFullYear(), now.getMonth()-i, 1);
    months.push({
      key: `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}`,
      label: d.toLocaleString('default',{month:'short'}),
      count: 0
    });
  }
  claims.forEach(c => {
    const mo = c.date?.slice(0,7);
    const bucket = months.find(m=>m.key===mo);
    if (bucket) bucket.count++;
  });

  const vals = months.map(m=>m.count);
  const maxV = Math.max(...vals, 1);
  const W=280, H=56, pad=4;
  const pts = vals.map((v,i) => {
    const x = pad + (i/(vals.length-1||1))*(W-pad*2);
    const y = H - pad - (v/maxV)*(H-pad*2);
    return [x,y];
  });

  // Smooth polyline
  const d = pts.map((p,i)=>i===0?`M${p[0]},${p[1]}`:`L${p[0]},${p[1]}`).join(' ');
  const area = d + ` L${pts[pts.length-1][0]},${H} L${pts[0][0]},${H} Z`;

  const svg = $('chart-spark');
  svg.setAttribute('viewBox',`0 0 ${W} ${H}`);
  svg.innerHTML = `
    <defs>
      <linearGradient id="sg" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stop-color="#3ecb6a" stop-opacity="0.25"/>
        <stop offset="100%" stop-color="#3ecb6a" stop-opacity="0.02"/>
      </linearGradient>
    </defs>
    <path d="${area}" fill="url(#sg)"/>
    <path d="${d}" fill="none" stroke="#3ecb6a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    ${pts.map((p,i)=>`<circle cx="${p[0]}" cy="${p[1]}" r="3" fill="#3ecb6a" stroke="white" stroke-width="1.5"/>
      <text x="${p[0]}" y="${p[1]-8}" text-anchor="middle" font-size="9" fill="#666" font-family="Inter,sans-serif">${vals[i]||''}</text>`).join('')}
  `;
  $('chart-spark-labels').innerHTML = months.map(m=>`<span>${m.label}</span>`).join('');
}

function updateStats(){
  const nw=claims.filter(c=>c.status==='New').length;
  const rs=claims.filter(c=>c.status==='Resolved').length;
  ['s-new','s-rs','s-all'].forEach((id,i)=>$(id).textContent=[nw,rs,claims.length][i]);
  ['c-all','c-new','c-rs'].forEach((id,i)=>$(id).textContent=[claims.length,nw,rs][i]);
}

function buildSidebar(){
  const types=[...new Set(claims.map(c=>c.type))].sort();
  const issues=[...new Set(claims.map(c=>c.issue))].sort();
  $('sb-types').innerHTML=types.map(t=>`<button class="t-btn" data-dim="type" data-val="${t}" onclick="applyF(this)">${t} <span class="t-cnt">${claims.filter(c=>c.type===t).length}</span></button>`).join('');
  $('sb-issues').innerHTML=issues.map(i=>`<button class="t-btn" data-dim="issue" data-val="${i}" onclick="applyF(this)">${i} <span class="t-cnt">${claims.filter(c=>c.issue===i).length}</span></button>`).join('');
}

function applyF(btn){
  const {dim,val}=btn.dataset;
  btn.closest('.t-sec').querySelectorAll('.t-btn').forEach(b=>b.classList.remove('active'));
  btn.classList.add('active');
  if(dim==='status') filt.status=val;
  else if(dim==='type') { filt.type=filt.type===val?null:val; if(!filt.type)btn.classList.remove('active'); }
  else if(dim==='issue'){ filt.issue=filt.issue===val?null:val; if(!filt.issue)btn.classList.remove('active'); }
  renderCharts();
  renderT();
}

function getF(){
  const q=($('t-q')?.value||'').toLowerCase();
  return claims.filter(c=>{
    if(filt.status!=='all'&&c.status!==filt.status)return false;
    if(filt.type&&c.type!==filt.type)return false;
    if(filt.issue&&c.issue!==filt.issue)return false;
    if(q&&!`${c.id} ${c.order} ${c.po} ${c.name} ${c.issue} ${c.desc}`.toLowerCase().includes(q))return false;
    return true;
  });
}

function renderT(){
  const rows=getF();
  const tbody=$('t-rows'),empty=$('t-empty');
  $('t-meta').textContent=`Showing ${rows.length} of ${claims.length} claims`;
  if(!rows.length){tbody.innerHTML='';empty.style.display='block';return;}
  empty.style.display='none';
  tbody.innerHTML=rows.map(c=>{
    const bc=c.status==='New'?'b-new':'b-ok';
    const u=`https://admin.shopify.com/store/labfresh/orders?query=${encodeURIComponent(c.order)}`;
    const th=c.img?`<img src="${c.img}" class="t-thumb">`:`<div class="t-no-img">📦</div>`;
    return `<tr onclick="openM('${c.id}')"><td>${th}</td><td style="font-weight:600;font-size:12px">${c.id}</td><td><a class="o-link" href="${u}" target="_blank" onclick="event.stopPropagation()">${c.order} <span class="arr">↗</span></a></td><td style="color:var(--grey-9);font-size:12px">${c.po}</td><td style="font-weight:500">${c.name}</td><td><span class="tag">${c.type}</span></td><td style="color:var(--grey-6);max-width:155px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">${c.issue}</td><td style="color:var(--grey-9);font-size:12px">${c.date}</td><td><span class="badge ${bc}">${c.status}</span></td></tr>`;
  }).join('');
}

/* ──── CLAIM DETAIL MODAL ───────────────────────── */
function openM(id){
  const c=claims.find(x=>x.id===id);
  if(!c)return;
  activeClaimId=id;
  const bc=c.status==='New'?'b-new':'b-ok';
  const u=`https://admin.shopify.com/store/labfresh/orders?query=${encodeURIComponent(c.order)}`;
  $('m-id').textContent=c.id;
  $('m-nm').textContent=c.name;
  $('m-dt').textContent=`Filed: ${c.date}`;
  $('m-bd').innerHTML=`
    ${c.img?`<img src="${c.img}" class="m-img">`:'<div class="m-no-img">No image uploaded</div>'}
    <div class="m-fields">
      <div class="m-f"><label>Email</label><p>${c.email}</p></div>
      <div class="m-f"><label>Shopify Order</label><p><a class="o-link" href="${u}" target="_blank">${c.order} ↗</a></p></div>
      <div class="m-f"><label>PO Number</label><p>${c.po}</p></div>
      <div class="m-f"><label>Product</label><p>${c.type}</p></div>
      <div class="m-f"><label>Colour</label><p>${c.colour}</p></div>
      <div class="m-f"><label>Status</label><p><span class="badge ${bc}">${c.status}</span></p></div>
    </div>
    <div class="m-issue-head">Issue — ${c.issue}</div>
    <div class="m-desc">${c.desc}</div>
  `;
  $('m-acts').innerHTML=`
    <button class="lf-btn btn-purple" onclick="openGorgias('${c.id}')">
      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/></svg>
      Reach out to customer
    </button>
    ${c.status!=='Resolved' ? `
    <div class="resolve-group" id="resolve-grp">
      <button class="lf-btn btn-green resolve-main" onclick="setS('${c.id}','Resolved')">Mark Resolved</button>
      <button class="resolve-caret" onclick="toggleResolveMenu(event)" title="Resolve with action">&#9662;</button>
      <div class="resolve-dropdown" id="resolve-dd">
        <div class="rd-header">Resolve with action</div>
        <button class="rd-item" onclick="openSA('replacement','${c.id}')">
          <div class="rd-item-icon" style="background:#fef9c3">&#128230;</div>
          <div class="rd-item-text">
            <div class="rd-item-title">Send Replacement</div>
            <div class="rd-item-sub">Prepare a €0 draft order for CS to send</div>
          </div>
        </button>
        <div class="rd-divider"></div>
        <button class="rd-item" onclick="openSA('giftcard','${c.id}')">
          <div class="rd-item-icon" style="background:#fce7f3">&#127873;</div>
          <div class="rd-item-text">
            <div class="rd-item-title">Send Gift Card</div>
            <div class="rd-item-sub">Issue Shopify gift card to customer</div>
          </div>
        </button>
        <div class="rd-divider"></div>
        <button class="rd-item" onclick="openSA('discount','${c.id}')">
          <div class="rd-item-icon" style="background:#d1fae5">&#127991;</div>
          <div class="rd-item-text">
            <div class="rd-item-title">Generate Discount Code</div>
            <div class="rd-item-sub">% or fixed off next order</div>
          </div>
        </button>
      </div>
    </div>` : ''}
    ${c.status!=='New' ? `<button class="lf-btn btn-ghost" onclick="setS('${c.id}','New')">Reopen</button>` : ''}
  `;
  $('m-ov').classList.add('open');
}

function closeM(e){
  if(!e||e.target===$('m-ov'))$('m-ov').classList.remove('open');
}

function setS(id,status){
  const c=claims.find(x=>x.id===id);
  if(c){c.status=status;save();closeM();initTeam();}
}

/* ──── GORGIAS MODAL ────────────────────────────── */
function openGorgias(id){
  const c=claims.find(x=>x.id===id);
  if(!c)return;

  // Reset to compose state
  $('g-compose').style.display='block';
  $('g-sending').style.display='none';
  $('g-success').style.display='none';

  // Pre-fill fields
  $('g-to').value=c.email;
  $('g-subject').value=`Your LABFRESH claim ${c.id} — ${c.issue}`;
  $('g-message').value=`Hi ${c.name.split(' ')[0]},\n\nThank you for filing a claim with us regarding your ${c.type} (${c.colour}, Order ${c.order}).\n\nOur product team has reviewed your case and we'd like to follow up with you directly.\n\n[Add your message here]\n\nWarm regards,\nThe LABFRESH Team`;
  $('g-tag').value='product-claim';
  $('g-preview-text').textContent=`${c.id} · ${c.type} · ${c.issue} · Order ${c.order} · PO: ${c.po}`;

  // Show config warning if not set up
  const configured=gCfg.domain&&gCfg.user&&gCfg.token;
  $('g-config-warning').style.display=configured?'none':'block';

  $('g-ov').classList.add('open');
}

function closeG(e){
  if(!e||e.target===$('g-ov'))$('g-ov').classList.remove('open');
}

async function sendGorgias(){
  const c=claims.find(x=>x.id===activeClaimId);
  if(!c)return;

  // Switch to sending state
  $('g-compose').style.display='none';
  $('g-sending').style.display='block';

  const domain=gCfg.domain||'';
  const user=gCfg.user||'';
  const token=gCfg.token||'';
  const fromAddress=gCfg.from||'hello@labfresh.eu';

  const bodyText=$('g-message').value;
  const bodyHtml=bodyText.replace(/\n/g,'<br>');
  const subject=$('g-subject').value;
  const tag=$('g-tag').value||'product-claim';
  const toEmail=$('g-to').value;

  const payload={
    customer:{ email:toEmail },
    subject,
    channel:'email',
    from_agent:true,
    via:'api',
    status:'open',
    tags:[{name:tag},{name:`claim-${c.id.toLowerCase()}`}],
    meta:{
      claim_id:c.id,
      po_number:c.po,
      shopify_order:c.order,
      product_type:c.type
    },
    messages:[{
      sender:{ email:user },
      receiver:{ email:toEmail },
      source:{
        to:[{address:toEmail}],
        from:{address:fromAddress}
      },
      subject,
      body_html:`<p>${bodyHtml}</p><hr style="margin:20px 0;border:none;border-top:1px solid #eee"><p style="font-size:12px;color:#999">Claim Reference: ${c.id} | Product: ${c.type} (${c.colour}) | Issue: ${c.issue} | Order: ${c.order} | PO: ${c.po}</p>`,
      body_text:`${bodyText}\n\n---\nClaim Reference: ${c.id} | Product: ${c.type} (${c.colour}) | Issue: ${c.issue} | Order: ${c.order} | PO: ${c.po}`,
      channel:'email',
      from_agent:true,
      via:'api'
    }]
  };

  let ticketUrl='';

  if(domain&&user&&token){
    try{
      const creds=btoa(`${user}:${token}`);
      const res=await fetch(`https://${domain}/api/tickets`,{
        method:'POST',
        headers:{
          'Content-Type':'application/json',
          'Accept':'application/json',
          'Authorization':`Basic ${creds}`
        },
        body:JSON.stringify(payload)
      });
      if(res.ok){
        const data=await res.json();
        ticketUrl=`https://${domain}/app/tickets/${data.id}`;
      } else {
        const err=await res.text();
        console.error('Gorgias error:',res.status,err);
        ticketUrl=`https://${domain}/app/tickets`;
      }
    }catch(err){
      console.error('Gorgias fetch failed:',err);
      ticketUrl=domain?`https://${domain}/app/tickets`:'https://app.gorgias.com';
    }
  } else {
    // Demo mode — simulate a delay
    await new Promise(r=>setTimeout(r,1800));
    ticketUrl='https://app.gorgias.com';
  }

  // Mark claim as resolved
  c.status='Resolved';
  save();

  // Show success
  $('g-ticket-url').href=ticketUrl;
  $('g-sending').style.display='none';
  $('g-success').style.display='block';
}

/* ──── EXPORT ───────────────────────────────────── */
const COLUMNS = [
  { key:'id',       label:'Ref #',          default:true  },
  { key:'date',     label:'Date Filed',     default:true  },
  { key:'status',   label:'Status',         default:true  },
  { key:'name',     label:'Customer Name',  default:true  },
  { key:'email',    label:'Email',          default:true  },
  { key:'order',    label:'Shopify Order',  default:true  },
  { key:'po',       label:'PO Number',      default:true  },
  { key:'type',     label:'Product Type',   default:true  },
  { key:'colour',   label:'Colour',         default:true  },
  { key:'issue',    label:'Issue Category', default:true  },
  { key:'desc',     label:'Description',    default:true  },
  { key:'img',      label:'Has Photo',      default:true  },
];

let expScope  = 'resolved';
let expFmt    = 'csv';
let expCols   = new Set(COLUMNS.filter(c=>c.default).map(c=>c.key));

function openExport() {
  expScope = 'resolved';
  expFmt   = 'csv';
  expCols  = new Set(COLUMNS.filter(c=>c.default).map(c=>c.key));

  // Reset UI
  $('exp-main').style.display = 'block';
  $('exp-progress').classList.remove('show');
  document.querySelectorAll('.scope-card').forEach(c=>c.classList.remove('selected'));
  $('scope-resolved').classList.add('selected');
  document.querySelectorAll('.scope-card .scope-check').forEach((el,i)=>{ el.textContent = i===0?'✓':''; });
  document.querySelectorAll('.fmt-opt').forEach(c=>c.classList.remove('selected'));
  $('fmt-csv').classList.add('selected');

  // Update counts
  const resolved = claims.filter(c=>c.status==='Resolved');
  const active = getF();
  const newOnly = claims.filter(c=>c.status==='New');
  $('scope-resolved-count').textContent = `${resolved.length} claim${resolved.length!==1?'s':''}`;
  $('scope-all-count').textContent      = `${claims.length} claim${claims.length!==1?'s':''}`;
  $('scope-filtered-count').textContent = `${active.length} claim${active.length!==1?'s':''}`;
  $('scope-new-count').textContent      = `${newOnly.length} claim${newOnly.length!==1?'s':''}`;

  // Build column checkboxes
  $('col-grid').innerHTML = COLUMNS.map(col => `
    <label class="col-check ${expCols.has(col.key)?'on':''}" id="col-${col.key}" onclick="toggleCol('${col.key}',this)">
      <input type="checkbox" ${expCols.has(col.key)?'checked':''}>
      <span class="col-dot">${expCols.has(col.key)?'✓':''}</span>
      ${col.label}
    </label>`).join('');

  updateExpPreview();
  $('exp-ov').classList.add('open');
}

function closeExp(e) {
  if (!e || e.target===$('exp-ov')) $('exp-ov').classList.remove('open');
}

function selectScope(val) {
  expScope = val;
  document.querySelectorAll('.scope-card').forEach(c=>c.classList.remove('selected'));
  $(`scope-${val}`).classList.add('selected');
  document.querySelectorAll('.scope-card .scope-check').forEach(el=>el.textContent='');
  $(`scope-${val}`).querySelector('.scope-check').textContent='✓';
  updateExpPreview();
}

function selectFmt(val) {
  expFmt = val;
  document.querySelectorAll('.fmt-opt').forEach(c=>c.classList.remove('selected'));
  $(`fmt-${val}`).classList.add('selected');
  updateExpPreview();
}

function toggleCol(key, el) {
  if (expCols.has(key)) expCols.delete(key);
  else expCols.add(key);
  el.classList.toggle('on', expCols.has(key));
  el.querySelector('.col-dot').textContent = expCols.has(key)?'✓':'';
  updateExpPreview();
}

function getScopedClaims() {
  if (expScope==='resolved')  return claims.filter(c=>c.status==='Resolved');
  if (expScope==='all')       return claims;
  if (expScope==='filtered')  return getF();
  if (expScope==='new')       return claims.filter(c=>c.status==='New');
  return claims;
}

function updateExpPreview() {
  const rows = getScopedClaims();
  const cols = COLUMNS.filter(c=>expCols.has(c.key));
  const withImg = rows.filter(c=>c.img).length;
  const fmtNames = { csv:'CSV spreadsheet', json:'JSON file', zip:'ZIP archive (CSV + images)' };
  const scopeNames = { resolved:'Resolved cases', all:'All claims', filtered:'Current filter', new:'New claims' };

  $('exp-preview-text').innerHTML =
    `<strong>${rows.length}</strong> claim${rows.length!==1?'s':''} from <strong>${scopeNames[expScope]}</strong> · ` +
    `<strong>${cols.length}</strong> column${cols.length!==1?'s':''} · ` +
    `Format: <strong>${fmtNames[expFmt]}</strong>` +
    (expFmt==='zip' ? ` · <strong>${withImg}</strong> photo${withImg!==1?'s':''}` : '');

  $('exp-foot-info').textContent = `${rows.length} rows · ${cols.length} columns`;
  $('exp-do-btn').disabled = rows.length===0 || cols.length===0;
}

async function doExport() {
  const rows = getScopedClaims();
  if (!rows.length) return;

  const cols = COLUMNS.filter(c=>expCols.has(c.key));
  const stamp = new Date().toISOString().slice(0,10);
  const scopeSlug = expScope;

  $('exp-main').style.display='none';
  $('exp-progress').classList.add('show');

  const setProgress = (pct, txt) => {
    $('prog-bar').style.width = pct+'%';
    $('prog-label').textContent = txt;
  };

  setProgress(10, 'Preparing data…');
  await tick();

  if (expFmt==='csv') {
    setProgress(40, 'Building spreadsheet…');
    await tick();
    const csv = buildCSV(rows, cols);
    setProgress(90, 'Finalising…');
    await tick();
    downloadBlob(csv, `labfresh-claims-${scopeSlug}-${stamp}.csv`, 'text/csv');
    setProgress(100, 'Done!');
    await delay(600);
    closeExp();
    initTeam();

  } else if (expFmt==='json') {
    setProgress(40, 'Serialising JSON…');
    await tick();
    const obj = rows.map(r => {
      const out = {};
      cols.forEach(c => {
        if (c.key==='img') out[c.label] = r.img ? 'Yes (base64 embedded)' : 'No';
        else out[c.label] = r[c.key] || '';
      });
      // Always embed image data in JSON if column selected
      if (expCols.has('img') && r.img) out['_imageBase64'] = r.img;
      return out;
    });
    setProgress(90, 'Finalising…');
    await tick();
    downloadBlob(JSON.stringify({
      exported: new Date().toISOString(),
      scope: expScope,
      total: rows.length,
      claims: obj
    }, null, 2), `labfresh-claims-${scopeSlug}-${stamp}.json`, 'application/json');
    setProgress(100, 'Done!');
    await delay(600);
    closeExp();
    initTeam();

  } else if (expFmt==='zip') {
    // Build zip manually using a simple zip encoder (no external libs needed for small datasets)
    setProgress(15, 'Building CSV…');
    await tick();
    const csvContent = buildCSV(rows, cols);

    setProgress(35, 'Processing images…');
    await tick();

    const zipFiles = [{ name:`claims-${stamp}.csv`, content: csvContent, isText: true }];

    // Add each image
    const withImages = rows.filter(r=>r.img);
    for (let i=0;i<withImages.length;i++) {
      const c = withImages[i];
      setProgress(35 + Math.round((i/withImages.length)*50), `Processing image ${i+1}/${withImages.length}…`);
      await tick();
      try {
        const base64 = c.img.split(',')[1];
        const ext = c.img.includes('png')?'png':'jpg';
        zipFiles.push({ name:`images/${c.id}.${ext}`, content: base64, isText: false, isBase64: true });
      } catch(e) { /* skip bad images */ }
    }

    setProgress(88, 'Creating ZIP archive…');
    await tick();

    // Build ZIP
    const zipBytes = buildZip(zipFiles);
    setProgress(96, 'Finalising…');
    await tick();
    downloadBytes(zipBytes, `labfresh-claims-${scopeSlug}-${stamp}.zip`, 'application/zip');
    setProgress(100, 'Done!');
    await delay(700);
    closeExp();
    initTeam();
  }
}

/* ── CSV builder ── */
function buildCSV(rows, cols) {
  const escape = v => {
    const s = String(v ?? '').replace(/"/g, '""');
    return (s.includes(',') || s.includes('"') || s.includes('\n')) ? `"${s}"` : s;
  };
  const header = cols.map(c=>escape(c.label)).join(',');
  const lines = rows.map(r =>
    cols.map(c => {
      if (c.key==='img') return escape(r.img ? 'Yes' : 'No');
      if (c.key==='order') return escape(r[c.key]);
      return escape(r[c.key] || '');
    }).join(',')
  );
  return [header, ...lines].join('\r\n');
}

/* ── Minimal ZIP builder (no dependencies) ── */
function buildZip(files) {
  const encoder = new TextEncoder();
  const parts = [];
  const centralDir = [];
  let offset = 0;

  const crc32 = (data) => {
    let crc = 0xFFFFFFFF;
    const table = crc32.table || (crc32.table = (() => {
      const t = new Uint32Array(256);
      for (let i=0;i<256;i++) { let c=i; for (let j=0;j<8;j++) c=c&1?(0xEDB88320^(c>>>1)):(c>>>1); t[i]=c; }
      return t;
    })());
    for (let i=0;i<data.length;i++) crc = table[(crc^data[i])&0xFF]^(crc>>>8);
    return (crc^0xFFFFFFFF)>>>0;
  };

  const uint16 = n => { const b=new Uint8Array(2); new DataView(b.buffer).setUint16(0,n,true); return b; };
  const uint32 = n => { const b=new Uint8Array(4); new DataView(b.buffer).setUint32(0,n,true); return b; };
  const concat = (...arrs) => { const l=arrs.reduce((s,a)=>s+a.length,0); const r=new Uint8Array(l); let o=0; for(const a of arrs){r.set(a,o);o+=a.length;} return r; };

  for (const f of files) {
    let data;
    if (f.isBase64) {
      const bin = atob(f.content);
      data = new Uint8Array(bin.length);
      for (let i=0;i<bin.length;i++) data[i]=bin.charCodeAt(i);
    } else {
      data = encoder.encode(f.content);
    }

    const nameBytes = encoder.encode(f.name);
    const crc = crc32(data);
    const now = new Date();
    const dosDate = ((now.getFullYear()-1980)<<9)|((now.getMonth()+1)<<5)|now.getDate();
    const dosTime = (now.getHours()<<11)|(now.getMinutes()<<5)|(now.getSeconds()>>1);

    const localHeader = concat(
      new Uint8Array([0x50,0x4B,0x03,0x04]), // sig
      uint16(20),        // version needed
      uint16(0),         // flags
      uint16(0),         // compression (stored)
      uint16(dosTime), uint16(dosDate),
      uint32(crc),
      uint32(data.length), uint32(data.length),
      uint16(nameBytes.length), uint16(0),
      nameBytes
    );

    const centralEntry = concat(
      new Uint8Array([0x50,0x4B,0x01,0x02]), // sig
      uint16(20), uint16(20),
      uint16(0), uint16(0),
      uint16(dosTime), uint16(dosDate),
      uint32(crc),
      uint32(data.length), uint32(data.length),
      uint16(nameBytes.length), uint16(0), uint16(0),
      uint16(0), uint16(0),
      uint32(0),
      uint32(offset),
      nameBytes
    );

    parts.push(localHeader, data);
    centralDir.push(centralEntry);
    offset += localHeader.length + data.length;
  }

  const centralBytes = concat(...centralDir);
  const eocd = concat(
    new Uint8Array([0x50,0x4B,0x05,0x06]),
    uint16(0), uint16(0),
    uint16(files.length), uint16(files.length),
    uint32(centralBytes.length),
    uint32(offset),
    uint16(0)
  );

  return concat(...parts, centralBytes, eocd);
}

/* ── Download helpers ── */
function downloadBlob(content, filename, type) {
  const blob = new Blob([content], { type });
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  a.click();
  setTimeout(()=>URL.revokeObjectURL(a.href), 5000);
}

function downloadBytes(bytes, filename, type) {
  const blob = new Blob([bytes], { type });
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  a.click();
  setTimeout(()=>URL.revokeObjectURL(a.href), 5000);
}

const tick  = () => new Promise(r=>requestAnimationFrame(r));
const delay = ms => new Promise(r=>setTimeout(r,ms));
function openCfg(){
  $('cfg-domain').value=gCfg.domain||'';
  $('cfg-user').value=gCfg.user||'';
  $('cfg-token').value=gCfg.token||'';
  $('cfg-from').value=gCfg.from||'';
  $('cfg-shopify-domain').value=gCfg.shopifyDomain||'';
  $('cfg-shopify-token').value=gCfg.shopifyToken||'';
  $('cfg-ov').classList.add('open');
}

function closeCfg(e){
  if(!e||e.target===$('cfg-ov'))$('cfg-ov').classList.remove('open');
}

function saveCfg(){
  gCfg={
    domain:$('cfg-domain').value.replace(/^https?:\/\//,'').replace(/\/$/,''),
    user:$('cfg-user').value,
    token:$('cfg-token').value,
    from:$('cfg-from').value,
    shopifyDomain:$('cfg-shopify-domain').value.replace(/^https?:\/\//,'').replace(/\/$/,''),
    shopifyToken:$('cfg-shopify-token').value
  };
  saveCfgData();
  closeCfg();
}

/* ──── SHOPIFY ACTIONS ───────────────────────────── */

// Close dropdown when clicking outside
document.addEventListener('click', () => {
  const dd = $('resolve-dd');
  if (dd) dd.classList.remove('open');
});

function toggleResolveMenu(e) {
  e.stopPropagation();
  const dd = $('resolve-dd');
  if (dd) dd.classList.toggle('open');
}

function openSA(type, claimId) {
  // close dropdown + main modal
  const dd = $('resolve-dd');
  if (dd) dd.classList.remove('open');
  $('m-ov').classList.remove('open');

  activeClaimId = claimId;
  const c = claims.find(x => x.id === claimId);
  if (!c) return;

  const hasSfCfg = !!(gCfg.shopifyDomain && gCfg.shopifyToken);

  if (type === 'replacement') {
    $('sa-rep-warn').style.display   = hasSfCfg ? 'none' : 'block';
    $('sa-rep-form').style.display   = 'block';
    $('sa-rep-result').style.display = 'none';
    $('sa-rep-foot').style.display   = 'flex';
    $('sa-rep-customer').textContent = c.name;
    $('sa-rep-order').textContent    = c.order;
    $('sa-rep-order-input').value    = c.order;
    $('sa-rep-note').value           = `Replacement for ${c.id} — ${c.issue}`;
    $('sa-replacement').classList.add('open');

  } else if (type === 'giftcard') {
    $('sa-gc-warn').style.display    = hasSfCfg ? 'none' : 'block';
    $('sa-gc-form').style.display    = 'block';
    $('sa-gc-result').style.display  = 'none';
    $('sa-gc-foot').style.display    = 'flex';
    $('sa-gc-customer').textContent  = c.name;
    $('sa-gc-msg').value             = `Hi ${c.name.split(' ')[0]}, sorry for the trouble with your ${c.type}. Here's a gift card on us.`;
    $('sa-giftcard').classList.add('open');

  } else if (type === 'discount') {
    $('sa-dc-warn').style.display    = hasSfCfg ? 'none' : 'block';
    $('sa-dc-form').style.display    = 'block';
    $('sa-dc-result').style.display  = 'none';
    $('sa-dc-foot').style.display    = 'flex';
    $('sa-dc-customer').textContent  = c.name;
    $('sa-discount').classList.add('open');
  }
}

function closeSA(id, e) {
  if (!e || e.target === $(id)) $(id).classList.remove('open');
}

function updateDiscountLabel() {
  const type = $('sa-dc-type').value;
  $('sa-dc-val-label').textContent = type === 'percentage' ? 'Discount Value (%)' : 'Discount Value (€)';
}

// ── SEND REPLACEMENT ──
async function execReplacement() {
  const c = claims.find(x => x.id === activeClaimId);
  if (!c) return;
  const btn = document.querySelector('#sa-replacement .sa-foot .lf-btn:last-child');
  btn.textContent = 'Preparing…'; btn.disabled = true;

  const sfDomain = gCfg.shopifyDomain || '';
  const sfToken  = gCfg.shopifyToken  || '';
  const code     = $('sa-rep-code').value || '-BI';
  const note     = $('sa-rep-note').value;

  let draftUrl = '#';

  if (sfDomain && sfToken) {
    try {
      // Fetch original order to get line items
      const searchRes = await shopifyFetch(
        `/admin/api/2025-01/orders.json?name=${encodeURIComponent(c.order)}&status=any`,
        'GET', null, sfDomain, sfToken
      );
      const origOrder = searchRes?.orders?.[0];

      const lineItems = origOrder?.line_items?.map(li => ({
        variant_id: li.variant_id,
        quantity: li.quantity,
        applied_discount: { description: 'Replacement', value_type: 'percentage', value: '100', amount: li.price }
      })) || [{ title: `Replacement — ${c.type} (${c.colour})`, quantity: 1, price: '0.00' }];

      // Create DRAFT order — CS reviews and completes before sending
      const payload = {
        draft_order: {
          line_items:  lineItems,
          email:       c.email,
          use_customer_default_address: true,
          note:        note || `Replacement for claim ${c.id} — awaiting CS review`,
          tags:        `claim-replacement,${c.id}`,
          send_receipt: false
        }
      };

      const res = await shopifyFetch('/admin/api/2025-01/draft_orders.json', 'POST', payload, sfDomain, sfToken);
      if (res?.draft_order?.id) {
        draftUrl = `https://${sfDomain}/admin/draft_orders/${res.draft_order.id}`;
      }
    } catch(err) {
      console.error('Shopify draft order error:', err);
    }
  } else {
    await delay(1600);
    draftUrl = 'https://admin.shopify.com/store/labfresh/draft_orders';
  }

  c.status = 'Resolved'; save();

  $('sa-rep-form').style.display   = 'none';
  $('sa-rep-foot').style.display   = 'none';
  $('sa-rep-result').style.display = 'block';
  $('sa-rep-link').href = draftUrl;
  initTeam();
}

// ── SEND GIFT CARD ──
async function execGiftCard() {
  const c = claims.find(x => x.id === activeClaimId);
  if (!c) return;
  const btn = document.querySelector('#sa-giftcard .sa-foot .lf-btn:last-child');
  btn.textContent = 'Issuing…'; btn.disabled = true;

  const sfDomain = gCfg.shopifyDomain || '';
  const sfToken  = gCfg.shopifyToken  || '';
  const value    = parseFloat($('sa-gc-value').value) || 50;
  const currency = $('sa-gc-currency').value;
  const msg      = $('sa-gc-msg').value;
  const expiry   = $('sa-gc-expiry').value || null;

  let lastChars = '****';

  if (sfDomain && sfToken) {
    try {
      // Use REST for gift cards (simpler, widely supported for Shopify Plus)
      const payload = {
        gift_card: {
          initial_value: value.toFixed(2),
          currency,
          customer_id: null, // will look up by email if possible
          note: `Issued for claim ${c.id} — ${c.issue}`,
          ...(expiry ? { expires_on: expiry } : {})
        }
      };
      const res = await shopifyFetch('/admin/api/2025-01/gift_cards.json', 'POST', payload, sfDomain, sfToken);
      if (res?.gift_card?.last_characters) {
        lastChars = '****' + res.gift_card.last_characters;
      }
    } catch(err) {
      console.error('Shopify gift card error:', err);
    }
  } else {
    await delay(1500);
    lastChars = '****' + Math.random().toString(36).slice(-4).toUpperCase();
  }

  c.status = 'Resolved'; save();

  $('sa-gc-form').style.display   = 'none';
  $('sa-gc-foot').style.display   = 'none';
  $('sa-gc-result').style.display = 'block';
  $('sa-gc-code').textContent     = lastChars;
  initTeam();
}

// ── GENERATE DISCOUNT CODE ──
async function execDiscount() {
  const c = claims.find(x => x.id === activeClaimId);
  if (!c) return;
  const btn = document.querySelector('#sa-discount .sa-foot .lf-btn:last-child');
  btn.textContent = 'Generating…'; btn.disabled = true;

  const sfDomain  = gCfg.shopifyDomain || '';
  const sfToken   = gCfg.shopifyToken  || '';
  const dcType    = $('sa-dc-type').value;
  const dcValue   = parseFloat($('sa-dc-value').value) || 20;
  const prefix    = ($('sa-dc-prefix').value || 'LF-CLAIM').toUpperCase().replace(/\s/g,'-');
  const expiryDays= parseInt($('sa-dc-expiry').value) || 90;
  const minOrder  = parseFloat($('sa-dc-minorder').value) || 0;

  // Generate unique code
  const suffix = Math.random().toString(36).slice(2,7).toUpperCase();
  const code   = `${prefix}-${suffix}`;

  const expiresAt = new Date(Date.now() + expiryDays * 86400000).toISOString();

  let finalCode = code;

  if (sfDomain && sfToken) {
    try {
      // 1. Create price rule
      const rulePayload = {
        price_rule: {
          title: `Claim ${c.id} — ${c.name}`,
          target_type: 'line_item',
          target_selection: 'all',
          allocation_method: 'across',
          value_type: dcType,
          value: dcType === 'percentage' ? `-${dcValue}` : `-${dcValue}`,
          customer_selection: 'all',
          once_per_customer: true,
          usage_limit: 1,
          starts_at: new Date().toISOString(),
          ends_at: expiresAt,
          ...(minOrder > 0 ? { prerequisite_subtotal_range: { greater_than_or_equal_to: minOrder.toFixed(2) } } : {})
        }
      };
      const ruleRes = await shopifyFetch('/admin/api/2025-01/price_rules.json', 'POST', rulePayload, sfDomain, sfToken);
      const ruleId  = ruleRes?.price_rule?.id;

      if (ruleId) {
        // 2. Create discount code under that rule
        const codePayload = { discount_code: { code: finalCode } };
        const codeRes = await shopifyFetch(`/admin/api/2025-01/price_rules/${ruleId}/discount_codes.json`, 'POST', codePayload, sfDomain, sfToken);
        finalCode = codeRes?.discount_code?.code || finalCode;
      }
    } catch(err) {
      console.error('Shopify discount error:', err);
    }
  } else {
    await delay(1400);
  }

  c.status = 'Resolved'; save();

  const typeLabel = dcType === 'percentage' ? `${dcValue}% off` : `€${dcValue} off`;
  $('sa-dc-form').style.display    = 'none';
  $('sa-dc-foot').style.display    = 'none';
  $('sa-dc-result').style.display  = 'block';
  $('sa-dc-code').textContent      = finalCode;
  $('sa-dc-details').textContent   = typeLabel + ' · Valid ' + expiryDays + ' days' + (minOrder > 0 ? ' · Min order \u20ac' + minOrder : '');
  initTeam();
}

// ── SHOPIFY API HELPER ──
async function shopifyFetch(path, method, body, domain, token) {
  const res = await fetch(`https://${domain}${path}`, {
    method,
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Access-Token': token
    },
    ...(body ? { body: JSON.stringify(body) } : {})
  });
  if (!res.ok) throw new Error(`Shopify ${method} ${path} → ${res.status}`);
  return res.json();
}

// Expose all functions globally for Shopify compatibility
window.switchView = switchView;
window.checkPin = checkPin;
window.cancelPin = cancelPin;
window.teamLogout = teamLogout;
window.isTeamAuthed = isTeamAuthed;
window.previewImgs = previewImgs;
window.submitClaim = function(e) { e.preventDefault(); submitClaim(e); };
window.resetForm = resetForm;
window.initTeam = initTeam;
window.renderCharts = renderCharts;
window.renderIssuesChart = renderIssuesChart;
window.renderProductsChart = renderProductsChart;
window.animateBars = animateBars;
window.renderDonut = renderDonut;
window.renderSparkline = renderSparkline;
window.updateStats = updateStats;
window.buildSidebar = buildSidebar;
window.applyF = applyF;
window.getF = getF;
window.renderT = renderT;
window.openM = openM;
window.closeM = closeM;
window.setS = setS;
window.openGorgias = openGorgias;
window.closeG = closeG;
window.sendGorgias = sendGorgias;
window.openExport = openExport;
window.closeExp = closeExp;
window.selectScope = selectScope;
window.selectFmt = selectFmt;
window.toggleCol = toggleCol;
window.getScopedClaims = getScopedClaims;
window.updateExpPreview = updateExpPreview;
window.doExport = doExport;
window.buildCSV = buildCSV;
window.buildZip = buildZip;
window.downloadBlob = downloadBlob;
window.downloadBytes = downloadBytes;
window.openCfg = openCfg;
window.closeCfg = closeCfg;
window.saveCfg = saveCfg;
window.toggleResolveMenu = toggleResolveMenu;
window.openSA = openSA;
window.closeSA = closeSA;
window.updateDiscountLabel = updateDiscountLabel;
window.execReplacement = execReplacement;
window.execGiftCard = execGiftCard;
window.execDiscount = execDiscount;
window.shopifyFetch = shopifyFetch;